import { SET_AUDIO_VOLUME, SELECT_THEME } from '../actions/types';
import persistFactory from './persistFactory';

export const initialState = {
  audioVolume: 0,
  theme: 'light', // default
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUDIO_VOLUME:
      return {
        ...state,
        audioVolume: action.volume,
      };
    case SELECT_THEME:
      return {
        ...state,
        theme: action.theme,
      };
    default:
      return state;
  }
};

export default persistFactory('uiReducer', uiReducer);
